import FieldTypesEnum from '../Enums/FieldTypesEnum';
import urlHelper from '../Helpers/urlHelper';

export default class AntiFraudToolAdminItem {
  constructor(item) {
    this.initialize(item);
    this.Selected = false;
  }

  async initialize(item) {
    this.FraudHitId = item.fraudHitId;
    this.Status = item.status;
    this.Matches = item.matches;
    this.OfficeId = item.officeId;
    this.CountryCode = item.countryCode;
    this.CountryName = item.countryName;
    this.RecordDate = item.recordDate;
    this.LastStatusChangeDate = item.lastStatusChangeDate;
    this.ShopperName = item.shopperName;
    this.AssignedToName = item.assignedToName;
    this.FieldworkOfficeName = item.fieldworkOfficeName;
  }

  static NameOfTheIdField() {
    return 'FraudHitId';
  }

  static nameOfTheItemDetailList() {
    return 'Fraud Hit';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = ['RecordDate', 'LastStatusChangeDate'];

  static BoolFields = [];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Record ID',
        orderById: 'FraudHitId',
        data: AntiFraudToolAdminItem.GetDetailCellContent,
        minWidth: 70,
      },
      {
        label: 'Base Shopper Name',
        orderById: 'ShopperName',
        data: 'ShopperName',
        type: FieldTypesEnum.PureDataField,
        minWidth: 100,
      },
      {
        label: 'Status',
        orderById: 'Status',
        data: 'Status',
        type: FieldTypesEnum.PureDataField,
        minWidth: 100,
      },
      {
        label: 'Assigned To',
        orderById: 'AssignedToName',
        data: 'AssignedToName',
        type: FieldTypesEnum.PureDataField,
        minWidth: 100,
      },
      {
        label: 'Country of Base Shopper',
        orderById: 'CountryName',
        data: 'CountryName',
        type: FieldTypesEnum.PureDataField,
        minWidth: 50,
      },
      {
        // label: 'FW Office',
        label: 'Ev. Pym Office',
        orderById: 'FieldworkOfficeName',
        data: 'FieldworkOfficeName',
        minWidth: 50,
      },
      {
        label: '# Matches',
        orderById: 'Matches',
        data: 'Matches',
        type: FieldTypesEnum.PureDataField,
        minWidth: 30,
      },
      {
        label: 'Detected Date',
        orderById: 'RecordDate',
        data: 'RecordDate',
        type: FieldTypesEnum.PureDataField,
        minWidth: 40,
      },
      {
        label: 'Status Change Date',
        orderById: 'LastStatusChangeDate',
        data: 'LastStatusChangeDate',
        type: FieldTypesEnum.PureDataField,
        minWidth: 40,
      },
    ];
  }

  static GetDetailCellContent(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.FraudHitId,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'fraudhitdetails',
      `fraudHitId=${item.FraudHitId}`,
      'Open up in a new tab'
    );
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'Info',
      tabLabel: 'Info',
      icon: 'fa-solid fa-info',
      data: [{ label: 'Record ID', name: 'RecordId' }],
    },
  ];
}
